import decode from 'jwt-decode'

import { getAuthToken } from 'utils/auth'
import { setCurrentUser } from '@src/redux/modules/auth'

export default function setCurrentUserToAuthedUser (store) {
  return (prevState) => {
    const authToken = getAuthToken()

    try {
      const decodedToken = decode(authToken)
      const userId = decodedToken.user_id
      store.dispatch(
        setCurrentUser(userId)
      )
    } catch (e) {
      window.location = '/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/middleware/setCurrentUserToAuthedUser.js